import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]

import { computed, onMounted, onUnmounted, ref } from "vue"
import { useRoute } from "vue-router"
import { authStore } from "@/store/login"
import { loadSession } from "@/composables/useSession"
import { registerAngularFrame, sayHelloToAngular, unregisterAngularFrame } from "@/utils/angularEmbed"


export default /*@__PURE__*/_defineComponent({
  __name: 'AngularEmbedPage',
  setup(__props) {

const route = useRoute()
const auth = authStore()

const $frame = ref<HTMLIFrameElement | null>(null)

onMounted(() => registerAngularFrame($frame))
onUnmounted(() => unregisterAngularFrame($frame))

const ANGULAR_URL = process.env.VUE_APP_ANGULAR_URL || ""

const iframeSrc = computed(() => {
	const angularPath = String((route.meta as Record<string, unknown>).angularPath ?? "")
	if (!angularPath || !ANGULAR_URL) return ""

	const session = loadSession()
	const token = String(auth.jwtToken ?? session?.jwtToken ?? "")
	const sessionKey = String(auth.sessionKey ?? session?.sessionKey ?? "")
	const userId = String(auth.currentUserId ?? session?.id ?? "")

	if (!token || !sessionKey || !userId) {
		return ""
	}

	const params = new URLSearchParams({
		token: token,
		sessionKey: sessionKey,
		userId: userId,
		embedded: "true",
	})
	return `${ANGULAR_URL}/${angularPath}?${params.toString()}`
})

return (_ctx: any,_cache: any) => {
  return (iframeSrc.value)
    ? (_openBlock(), _createElementBlock("iframe", {
        key: 0,
        ref_key: "$frame",
        ref: $frame,
        class: "angular-frame",
        src: iframeSrc.value,
        title: "Angular page",
        onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(sayHelloToAngular) && _unref(sayHelloToAngular)(...args)))
      }, null, 40, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})